import axios from 'axios'
import { stringify } from 'qs'
import { URL_DOMAIN, TEXT_PREFIX } from '../../config.json'
export async function getZoneList(params) {
    return axios.get(
        `${URL_DOMAIN}${TEXT_PREFIX}/basic-public/getTimezoneDict?${stringify(
            params
        )}`
    )
}
export async function getTicketDeployTemplateList(params) {
    return axios.get(
        `${URL_DOMAIN}${TEXT_PREFIX}/ws-service/message/getTicketDeployTemplateList/4?${stringify(
            params
        )}`
    )
}
export async function userIint(params) {
    return axios.get(
        `${URL_DOMAIN}${TEXT_PREFIX}/chat-visit/user/ticket/init?${stringify(
            params
        )}`
    )
}
export async function getInfo(params) {
    return axios.get(
        `${URL_DOMAIN}${TEXT_PREFIX}/chat-web/data/invokeOtherByUser.action?${stringify(
            params
        )}`
    )
}

export async function sendMsg(params) {
    return axios.post(
        `${URL_DOMAIN}${TEXT_PREFIX}/chat-web/data/postMsg.action`,
        params
    )
}

export async function getTicketTypeInfoList(params) {
    return axios.post(
        `${URL_DOMAIN}${TEXT_PREFIX}/chat-web/data/invokeOtherByUser.action?${stringify(
            params
        )}`
    )
}

export async function getTicketRegionList(pid) {
    return axios.get(
        `${URL_DOMAIN}${TEXT_PREFIX}/ws-service/getTicketRegionList/${pid}`
    )
}

// 搜索地区
export const searchArea = (data) => {
    return axios.post(
        `${URL_DOMAIN}${TEXT_PREFIX}/ws-service/searchTicketRegion/4`,
        data,
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    )
}
